import { Context, Provider } from './notification.component.js';

var index = { Context, Provider };

export { index as default };
